import React from 'react';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import Accordion from '@src/components/Accordion';
import FontIcon from '@src/components/FontIcon';
import { Body2, H2 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';
import { TourProgram } from '@src/types';

import { Content } from './styled';

type Props = {
  items: TourProgram[];
};

const Row = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 0 ${padding}px;
  align-items: center;
  height: 36px;
`;
const Header = React.memo(
  ({
    section,
    active,
  }: {
    section: TourProgram;
    index: number;
    active: boolean;
  }) => (
    <>
      <Row>
        <H2>{section.title}</H2>
        <FontIcon name={active ? 'chevron-up' : 'chevron-down'} size={10} />
      </Row>
    </>
  )
);

const ContentWrapper = styled.View`
  padding: 0 ${padding}px 0 ${padding}px;
`;

const Component: React.FC<Props> = ({ items }) => {
  const renderHeader = React.useCallback(
    (section: TourProgram, index: number, isActive: boolean) => (
      <Header index={index} section={section} active={isActive} />
    ),
    []
  );
  const renderContent = React.useCallback(
    (section: TourProgram) => (
      <ContentWrapper>
        <Body2>{section?.description}</Body2>
      </ContentWrapper>
    ),
    []
  );

  if (items.length === 0) {
    return null;
  }
  return (
    <>
      <Content>
        <H2>
          <Trans>Tour schedule</Trans>
        </H2>
      </Content>
      <Accordion<TourProgram>
        list={items}
        header={renderHeader}
        body={renderContent}
        keyExtractor={(item: { title: any }) => `${item.title}`}
      />
    </>
  );
};

Component.displayName = 'Programs';

export default Component;
